import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { useTranslation } from "react-i18next";

import { Z_INDEX_ORDERS } from "@/pages/config/zIndexOrders.const";

import { TABLE_UNIT_CARD_NS } from "../../TableUnitCard.i18n";

export const DraggableHandle = ({
  className,
  direction,
  dndId,
  meta,
  ...props
}: {
  direction: "left" | "right";
  dndId: string;
  meta: {
    cellId: string;
    row: string;
    column: string;
    cellIndex: number;
    cellSpan: number;
  };
} & React.HTMLProps<HTMLDivElement>) => {
  const { t } = useTranslation(TABLE_UNIT_CARD_NS);
  const metaData = {
    data: {
      cellIndex: meta.cellIndex,
      cellSpan: meta.cellSpan,
      cellId: meta.cellId,
      direction,
    },
    target: "span-control",
  };

  const id = `span-control-${direction}-${dndId}`;

  const { attributes, isDragging, listeners, setNodeRef, transform } =
    useDraggable({
      id,
      data: metaData,
    });

  return (
    <div
      ref={setNodeRef}
      aria-label={t("aria.drag-handle", { direction })}
      aria-orientation="horizontal"
      className={[
        "cursor-col-resize hover:bg-neutral-350",
        isDragging && "outline outline-blue-500 bg-blue-600! handle-dragging",
        "absolute top-1/2 transform -translate-y-1/2 bg-neutral-150 w-[12px] py-[36px] rounded-lg flex-shrink-0 group-has-[&.card-dragging]:invisible",
        Z_INDEX_ORDERS.EDIT_SUBJECT_PLAN.DRAGGABLE_HANDLE,
        `${direction}-1`,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      id={id}
      {...listeners}
      {...attributes}
      {...props}
      style={{
        transform: CSS.Translate.toString(
          transform
            ? {
                ...transform,
                y: transform ? transform.y + 5 : 0,
              }
            : null
        ),
      }}
    />
  );
};
